import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ShopService from '../services/ShopService';
import { isEmpty } from 'lodash';

const initialState = {
  data: [],
  datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  status: '',
  loading: false,
  submitLoading: false,
};

export const shopList = createAsyncThunk(
  'shop/list',
  async ({ perPage, page, keyword, region_id, warehouse_id }) => {
    try {
      const resp = await ShopService.List({ perPage, page, keyword, region_id, warehouse_id });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const shopAdd = createAsyncThunk('shop/add', async (data, { rejectWithValue }) => {
  try {
    const resp = await ShopService.Create(data);
    return resp;
  } catch (e) {
    return rejectWithValue(e.response);
  }
});

export const shopEdit = createAsyncThunk('shop/edit', async ({ id, data }, { rejectWithValue }) => {
  try {
    const resp = await ShopService.Put(id, data);
    return resp;
  } catch (e) {
    return rejectWithValue(e.response);
  }
});

export const shopDelt = createAsyncThunk('shop/delt', async (id) => {
  try {
    const resp = await ShopService.Delt(id);
    return resp;
  } catch (e) {
    return e.response;
  }
});

const shopAction = createSlice({
  name: 'shop',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(shopList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(shopList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data?.data?.shops];
          state.pagination = action.payload?.data?.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(shopList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(shopAdd.pending, (state, action) => {
        state.submitLoading = true;
        state.isSuccess = false;
      })
      .addCase(shopAdd.fulfilled, (state, action) => {
          state.datas.unshift(action.payload.data.data);
          toast.success(action.payload?.data.message);
        state.submitLoading = false;
        state.isSuccess = true;
      })
      .addCase(shopAdd.rejected, (state, action) => {
        state.submitLoading = false;
        state.isSuccess = false;
        const errors = action.payload?.data?.errors;
        if (isEmpty(errors)) {
            toast.error(action.payload?.data?.message || 'Something went wrong');
        } else {
            state.formError = errors;
        }
      })
      .addCase(shopEdit.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
        state.isSuccess = false;
      })
      .addCase(shopEdit.fulfilled, (state, action) => {
        state.isSuccess = true;
        if (action.payload?.status === 200) {
          state.info = action.payload?.data.message;
          const index = state.datas.findIndex(
            (client) => client.id === action.payload.data.data.shop.id,
          );
          state.datas[index] = {
            ...state[index],
            ...action.payload.data?.data?.shop,
          };
          toast.success(action.payload?.data.message);
        } else {
          toast.error(action.payload?.data.errors);
        }
        state.submitLoading = false;
      })
      .addCase(shopEdit.rejected, (state, action) => {
        state.submitLoading = false;
        const errors = action.payload?.data?.errors;
        state.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      .addCase(shopDelt.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
      })
      .addCase(shopDelt.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          let index = state.datas.findIndex(({ id }) => id === action.payload.data.data.id);
          state.datas.splice(index, 1);
          state.info = action.payload?.data.message;
          toast.success(action.payload?.data.message);
        }
        state.submitLoading = false;
      })
      .addCase(shopDelt.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      });
  },
});

const { reducer } = shopAction;

export default reducer;
